import React from 'react';

import type { FidelityPanel, MetricFormat } from './presentationModel';

const subsets: Record<string, { key: string; label: string }> = {
  newMembers: { key: 'newMembersPromo', label: 'promo' },
  returningMembers: { key: 'returningMembersPromo', label: 'promo' },
  cancelled: { key: 'autoRenewOffActive', label: 'active' },
  churned: { key: 'churnedPromo', label: 'promo' },
};

export default function OverviewMembershipMetrics({
  panel,
  format,
}: {
  panel: FidelityPanel;
  format: (value: number | null, kind: MetricFormat) => string;
}) {
  const metrics = panel.metrics ?? [];
  const subsetKeys = new Set(Object.values(subsets).map(({ key }) => key));
  return (
    <dl className="lp-kpis lp-membership-metrics">
      {metrics
        .filter((metric) => !subsetKeys.has(metric.key))
        .map((metric) => {
          const subset = subsets[metric.key];
          const secondary = subset && metrics.find(({ key }) => key === subset.key);
          return (
            <div key={metric.key} title={metric.definition}>
              <dt>{metric.label.replace(' (all countries)', '')}</dt>
              <dd data-lp-metric={metric.key}>{format(metric.value, metric.format)}</dd>
              {secondary && (
                <dd className="lp-membership-subset" title={secondary.definition}>
                  (<span data-lp-metric={secondary.key}>{format(secondary.value, secondary.format)}</span>{' '}
                  {subset.label})
                </dd>
              )}
            </div>
          );
        })}
    </dl>
  );
}
